module.exports = __webpack_public_path__ + "static/media/testfile_sstrimapmatting.14be254f.zip";